module.exports = __webpack_public_path__ + "media/photo/Group 423-6039c8b1.jpg";